import type { ResourcesConfig } from 'aws-amplify';

// Environment-based configuration
const stage = import.meta.env.VITE_STAGE || (import.meta.env.PROD ? 'prod' : 'dev');

const userPoolId = import.meta.env.VITE_USER_POOL_ID;
const userPoolClientId = import.meta.env.VITE_USER_POOL_CLIENT_ID;
const cognitoDomain = import.meta.env.VITE_COGNITO_DOMAIN;

// Validate required configuration at startup
if (!userPoolId || userPoolId.includes('PLACEHOLDER')) {
  throw new Error(
    'Missing VITE_USER_POOL_ID environment variable. ' +
      'Set it in .env.local for development or ensure CI/CD provides it.'
  );
}
if (!userPoolClientId || userPoolClientId.includes('PLACEHOLDER')) {
  throw new Error(
    'Missing VITE_USER_POOL_CLIENT_ID environment variable. ' +
      'Set it in .env.local for development or ensure CI/CD provides it.'
  );
}

// Log configuration for debugging (non-sensitive info only)
if (import.meta.env.DEV) {
  globalThis.console.log(`[Amplify] Stage: ${stage}, UserPoolId: ${userPoolId.split('_')[0]}...`);
}

// Build redirect URLs based on current origin
// MUST match callbackUrls/logoutUrls in Cognito UserPoolClient (data-stack.ts)
const origin = typeof window !== 'undefined' ? window.location.origin : '';
const redirectSignIn = `${origin}/auth/callback`;
const redirectSignOut = `${origin}/auth/logout`;

// Base Amplify configuration
export const amplifyConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId,
      userPoolClientId,
      // OAuth configuration for social sign-in (Apple, Google)
      // Only enabled if cognitoDomain is configured
      ...(cognitoDomain && {
        loginWith: {
          oauth: {
            domain: cognitoDomain,
            scopes: ['email', 'openid', 'profile'],
            redirectSignIn: [redirectSignIn],
            redirectSignOut: [redirectSignOut],
            responseType: 'code',
          },
        },
      }),
    },
  },
};

/**
 * Check if OAuth is configured (Cognito domain is set)
 */
export function isOAuthConfigured(): boolean {
  return Boolean(cognitoDomain);
}
